import React, { FC } from 'react'

import { PageLayout } from 'Components'

export const ErrorMessage: FC = () => {
  return (
    <>
      <h2 className="text-center">Etwas ist schiefgegangen</h2>

      <p>Leider ist uns ein Fehler passiert, versuchen Sie es bitte später erneut.</p>

      <p>
        Melden Sie sich bitte beim Support, falls der Fehler wiederholt auftritt:{' '}
        <a href="mailto:info@eBalance.ch">info@eBalance.ch</a>
      </p>
    </>
  )
}

const ErrorPage: FC = () => {
  return (
    <PageLayout variant="smallcircle">
      <div className="container max-500">
        <ErrorMessage />
      </div>
    </PageLayout>
  )
}

export default ErrorPage
